<template>
<div>
    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
        <!-- Alert -->
        <Alert v-if="alertType !== ''" :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <!--Promotion card-->
        <v-card v-for="(promotion, key) in promotions" :key="key" class="m-3 semi-transparent-5-bg rounded-border" >

            <v-img
                class="effect"
                v-show="promotion.promotion_details[lang].url"
                :src="promotion.promotion_details[lang].url"
                contain
                @click="openDialog(promotion)"
            >
            </v-img>

        </v-card>

        <Dialog :dialog="dialog" :promotion="selectedItem" @DialogChanged="dialog = $event.value"/>
    </v-flex>
</div>
</template>

<script>
import Alert from "@/components/Reusable/Alert.vue";
import Dialog from "@/components/Promotions/Dialog.vue";
import Api from "@/api";

export default {
    name: "Promotion",
    data() {
        return {
            alertType: "",
            message: "",
            visibility: false,
            progressbar: false,
            promotions: [],
            lang: 'en',
            selectedItem: {
                name: "",
                url: "",
                description: ""
            },
            dialog: false
        }
    },
    components: {
        Alert,
        Dialog
    },
    created: function() {
        this.getPromotions();
        //this.lang = this.$store.getters.lang_flag;
    },
    methods: {
         async getPromotions() {

            this.progressbar = true;

            let res = await Api.getPromotions();

            this.progressbar = false;

            let currentInstance = this;

            if (res && 'success' in res && res.success === true) {

                this.promotions = res.data.map(function(promotion) {

                    if(promotion.promotion_details) {

                        promotion.promotion_details = currentInstance.arrayToObject(promotion.promotion_details, 'language')

                    }

                    if(promotion.token_promotion_details) {

                        promotion.promotion_details = currentInstance.arrayToObject(promotion.token_promotion_details, 'language');

                    }

                    return promotion;
                });

            } else {

                this.visibility = true;

                this.message = res.message;

                this.alertType = "error";

            }

        },
        arrayToObject(array, key) {

            return array.reduce((obj, item) => {

                obj[item[key]] = item;

                return obj;

            }, {});

        },
        openDialog(promotion) {

            this.dialog = !this.dialog;

            this.selectedItem.name = promotion.name;

            this.selectedItem.url = promotion.promotion_details[this.lang].url;

            this.selectedItem.description = promotion.promotion_details[this.lang].description;

        }
    }
}
</script>

<style scoped>
    .shadow{
        -webkit-box-shadow: 18px 28px 24px 1px rgba(0,0,0,0.75);
        -moz-box-shadow: 18px 28px 24px 1px rgba(0,0,0,0.75);
        box-shadow: 18px 28px 24px 1px rgba(0,0,0,0.75);
        border:5px solid black;
    }

    .effect {
        /* animation: fadeIn 1s infinite; */
        cursor:pointer;
    }

    @keyframes fadeIn {
         0% {
            opacity: 0.8;
        }
        50% {
            opacity: 0.9;
        }
        100% {
            opacity: 1;
        }
    }
</style>
